import { render } from "./accordion-form-section.vue?vue&type=template&id=746f3016&lang=pug"
import script from "./accordion-form-section.vue?vue&type=script&lang=js"
export * from "./accordion-form-section.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__